import type { NumericPoint } from "./numeric-series";

/** Split a sorted series at gaps larger than `maxGap`. */
export function segmentByGap<Y>(
  points: readonly NumericPoint<Y>[],
  maxGap: number,
): NumericPoint<Y>[][] {
  if (points.length === 0) return [];

  const segments: NumericPoint<Y>[][] = [];
  let current: NumericPoint<Y>[] = [];

  for (const point of points) {
    if (
      current.length > 0 &&
      point[0] - current[current.length - 1][0] > maxGap
    ) {
      segments.push(current);
      current = [];
    }
    current.push(point);
  }

  if (current.length > 0) segments.push(current);
  return segments;
}
